import React from 'react';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import Toast, { BaseToast, ErrorToast } from 'react-native-toast-message';
import ConfirmDialog from './src/components/ConfirmDialog';
import { AuthProvider } from './src/context/AuthContext';
import { LanguageProvider } from './src/context/LanguageContext';
import AppNavigator from './src/navigation/AppNavigator';

const toastConfig = {
  success: (props: React.ComponentProps<typeof BaseToast>) => (
    <BaseToast
      {...props}
      style={{ borderLeftColor: '#4CAF50', minHeight: 80, paddingVertical: 12 }}
      contentContainerStyle={{ paddingHorizontal: 16 }}
      text1Style={{ fontSize: 17, fontWeight: '700' }}
      text2Style={{ fontSize: 15 }}
      text2NumberOfLines={4}
    />
  ),
  error: (props: React.ComponentProps<typeof ErrorToast>) => (
    <ErrorToast
      {...props}
      style={{ borderLeftColor: '#F44336', minHeight: 80, paddingVertical: 12 }}
      contentContainerStyle={{ paddingHorizontal: 16 }}
      text1Style={{ fontSize: 17, fontWeight: '700' }}
      text2Style={{ fontSize: 15 }}
      text2NumberOfLines={4}
    />
  ),
  info: (props: React.ComponentProps<typeof BaseToast>) => (
    <BaseToast
      {...props}
      style={{ borderLeftColor: '#2196F3', minHeight: 80, paddingVertical: 12 }}
      contentContainerStyle={{ paddingHorizontal: 16 }}
      text1Style={{ fontSize: 17, fontWeight: '700' }}
      text2Style={{ fontSize: 15 }}
      text2NumberOfLines={4}
    />
  ),
};

const App: React.FC = () => {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <SafeAreaProvider>
        <AuthProvider>
          <LanguageProvider>
            <AppNavigator />
            <Toast config={toastConfig} />
            <ConfirmDialog />
          </LanguageProvider>
        </AuthProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
};

export default App;
